import React, { useEffect, useState } from "react";

export const useCursor: () => [boolean, () => void] = () => {
	const [cursor, setCursor] = useState(false)

	useEffect(() => {
		let timer = setInterval(() => {
			setCursor(!cursor)
		}, 500)
		return () => clearInterval(timer)
	})

	return [cursor, () => setCursor(true)]
}